import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { EnrollmentNew } from 'src/app/modules/enrollments/models/enrollment-new.model';
import { Class } from 'src/app/modules/classes/models/class.model';
import { ClassService } from 'src/app/modules/classes/services/class.service';

@Component({
    selector: 'app-enrollment-edit-step-courses',
    templateUrl: './enrollment-edit-step-courses.component.html',
    styleUrls: ['./enrollment-edit-step-courses.component.scss']
})
export class EnrollmentEditStepCoursesComponent implements OnInit {

    @Input() enrollment: EnrollmentNew;

    @Output() enrollmentChange = new EventEmitter<EnrollmentNew>();
    @Output() isCompleteStep   = new EventEmitter<boolean>();

    public labels: any = {

        classSelectorLabel: 'Seleccione las clases en las que desee matricular al participante',

    }

    public isLoadingData : boolean = true;
    public loadingMessage: AlertMessage = new AlertMessage();
    public loadingErrorMessage: string  = 'Se ha producido un error al cargar la página.';

    public classes: Class[];

    constructor(private classService: ClassService) { }

    ngOnInit (): void {

        this.initData();

    }

    private initData() {

        let editionId = this.enrollment.edition.editionId;
        let studentYear = new Date(this.enrollment.student.birthDate).getFullYear();

        forkJoin({

            classesRequest: this.classService.getByEditionAndStudentAge(editionId, studentYear)

        }).subscribe({

            next: (requests: any) => {

                this.classes   = requests.classesRequest;

            },

            error: (error: any) => {

                this.loadingMessage.showDangerAlert(this.loadingErrorMessage);

            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }

    public isFormValid() {

        let isValidClasses = this.enrollment.classes && this.enrollment.classes !== null && this.enrollment.classes.length > 0;

        return isValidClasses;

    }

    public onEnrollmentChange() {

        this.isCompleteStep.emit(this.isFormValid());
        this.enrollmentChange.emit(this.enrollment);

    }

}
